/**
 * HTTP method groupings shared across interceptors and guards.
 */

/**
 * Methods that mutate server state - used to decide when to attach
 * request-scoped security headers (e.g. a CSRF token) rather than on
 * every request.
 */
export const UNSAFE_HTTP_METHODS: ReadonlyArray<string> = ['POST', 'PUT', 'PATCH', 'DELETE'];
